import "@arcgis/map-components/components/arcgis-weather";
import "./weather.css";

function Weather() {
  return (
    <>
      <arcgis-weather referenceElement="viewDiv"></arcgis-weather>

    </>
  );
}

export default Weather;
